/**
 * @param {object} data
 * @return {{feature: string, zone}}
 */
export const newsletter = (data) => ({
  feature: 'newsletter',
  zone: data.zone,
});
